import React from 'react';


const formatDeletionDate =
  (value) => {

    if (!value) {
      return '';
    }


    const date =
      new Date(value);


    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return '';
    }


    return date.toLocaleDateString(
      undefined,
      {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }
    );
  };


const FamilyInactiveBanner = ({
  ownerName,
  deletionScheduledFor,
  isAdminDeletionScheduled,
  status,
}) => {

  const deletionDate =
    formatDeletionDate(
      deletionScheduledFor
    );


  return (
    <div
      className="rounded-xl border border-red-300 dark:border-red-800 bg-red-50 dark:bg-red-950/35 px-5 py-4 text-red-900 dark:text-red-200 shadow-sm"
      role="status"
      aria-live="polite"
    >

      <div className="flex items-start gap-3">

        <div
          className="text-xl leading-none mt-0.5"
          aria-hidden="true"
        >
          ⚠️
        </div>


        <div className="min-w-0">

          <div className="font-bold text-base">
            This family is currently read-only.
          </div>


          <p className="mt-1 text-sm leading-relaxed">
            You can continue to view family information,
            but changes are disabled. {isAdminDeletionScheduled ? 'This deletion was scheduled by MyPiggy support and cannot be recovered by the Family Owner.' : status === 'admin_read_only' ? 'Please contact MyPiggy support about this administrator hold.' : <>Only Family Owner{' '}
            <span className="font-semibold">
              {ownerName ||
                'Family Owner'}
            </span>{' '}
            can reactivate the family during an eligible recovery period.</>}
          </p>


          {deletionDate && (

            <p className="mt-2 text-sm font-semibold">
              {isAdminDeletionScheduled
                ? 'This family is eligible for permanent deletion at the next daily purge.'
                : <>This family is scheduled for permanent deletion on{' '}{deletionDate}.</>}
            </p>

          )}

        </div>

      </div>

    </div>
  );
};


export default FamilyInactiveBanner;
